import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import editTokens from '@amzn/meridian-tokens/base/icon/edit';
import type { JagListViewFragment } from 'generated/graphql';
import type { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

export type EditJagButtonProps = {
  jag: JagListViewFragment;
};

export const EditJagButton: FC<EditJagButtonProps> = ({ jag }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const editJAG = () => navigate(`${location.pathname}/${jag.id}`);

  return (
    <Button data-cy={`${jag.id}-edit-button`} onClick={editJAG} type="icon">
      <Icon tokens={editTokens}>Edit</Icon>
    </Button>
  );
};
